import { Size } from '@shared/components/image/models';

/**
 * Returns a parameter string including width and height
 * for image resizing transformations in a CDN or similar service.
 *
 * @param imageSize - An object with numeric width and height properties.
 * @returns A formatted string with width and height.
 */
export const getSizes = (imageSize: Size): string => {
  // Initialize an empty array to hold size parameters
  const params: string[] = [];

  // Add width to parameters if it is greater than 0
  if (imageSize.width > 0) {
    params.push(`width=${imageSize.width}`);
  }

  // Add height to parameters if it is greater than 0
  if (imageSize.height > 0) {
    params.push(`height=${imageSize.height}`);
  }

  // Concatenate parameters with a comma and prepend the result with a comma
  return params.length > 0 ? `${params.join(',')}` : '';
};
